export class FileConstants {
    // FILE 
    static readonly DOCX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'; //.docx
    static readonly PDF_MIME_TYPE = 'application/pdf'; //.pdf
    static readonly ALLOWED_FILE_TYPES = [FileConstants.DOCX_MIME_TYPE, FileConstants.PDF_MIME_TYPE]; //allowed types
    static readonly ALLOWED_FILE_SIZE = 2097152; //2 mb

    static readonly REPLACE_STRING = 'data:application/pdf;base64,';


    static readonly FILE_SIZE_GENERAL = 768000; // 750 KB
    static readonly FILE_SIZE_LARGE = 2097152; // Resume , Offer Letter, Forms -ONboard // 2 MB
    static readonly FILE_SIZE_ZIP = 4194304; // 4 MB
    static readonly FILE_SIZE_EXCEL = 1048576; // 1 MB

    // IMAGE
    static readonly JPEG_MIME_TYPE = 'image/jpeg'; //.jpg,.jpeg
    static readonly PNG_MIME_TYPE = 'image/png'; //.png

    static readonly ALLOWED_IMAGE_EXTNS = ['png', 'jpg', 'jpeg']; //allowed Extentions
    static readonly ALLOWED_IMAGE_TYPES = [FileConstants.JPEG_MIME_TYPE, FileConstants.PNG_MIME_TYPE]; // Allowed Types
    static readonly ALLOWED_IMAGE_SIZE = 512000; //500 kb

}